import React from 'react';
import { Building2, Dumbbell, MapPin, Users, ArrowLeft } from 'lucide-react';
import Reveal from './Reveal';

const AUDIENCES = [
  {
    icon: Building2,
    title: 'الأندية والأكاديميات',
    description: 'لاعبون واشتراكات وفرق وفئات وحضور ومالية وتقارير — نظام إدارة كامل لمنشأتك.',
    cta: 'سجّل منشأتك',
    to: '/register',
    key: 'club',
    featured: true,
  },
  {
    icon: Dumbbell,
    title: 'المدربون',
    description: 'ملف مدرب احترافي، خطط تدريبية، تمارين، وتحليل مباريات — واستقبل عروض العمل من المنشآت.',
    cta: 'انضم كمدرب',
    to: '/coaches',
    key: 'coach',
  },
  {
    icon: MapPin,
    title: 'ملاك الملاعب',
    description: 'اعرض ملاعبك، استقبل الحجوزات، ونظّم المواعيد والمدفوعات من لوحة واحدة.',
    cta: 'سجّل ملعبك',
    to: '/venue-owner/register',
    key: 'venue',
  },
  {
    icon: Users,
    title: 'أولياء الأمور',
    description: 'تابع حضور ابنك واشتراكه ومدفوعاته وتقارير تطوّره أولاً بأول من جوالك.',
    cta: 'بوابة ولي الأمر',
    to: '/register?type=parent',
    key: 'parent',
  },
];

export const LandingAudiences = ({ landing, navigate }) => (
  <section id="audiences" className="mx-auto max-w-7xl px-5 py-20 md:py-28" data-testid="landing-audiences">
    <Reveal>
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-sm font-bold uppercase tracking-wider text-teal-400">لمن تسيار؟</span>
        <h2 className="font-display mt-3 text-2xl font-bold text-white sm:text-3xl lg:text-4xl" data-testid="landing-audiences-title">
          {landing?.audiences_title || 'منصة واحدة… لأربعة أدوار'}
        </h2>
        <p className="mt-3 text-slate-400" data-testid="landing-audiences-subtitle">
          {landing?.audiences_subtitle || 'كل طرف في المنظومة الرياضية له حسابه وأدواته داخل تسيار'}
        </p>
      </div>
    </Reveal>

    <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {AUDIENCES.map((a, i) => (
        <Reveal key={a.key} delay={i * 70}>
          <button
            onClick={() => navigate(a.to)}
            data-testid={`landing-audience-${a.key}`}
            className={`group flex h-full w-full flex-col rounded-2xl border p-6 text-start transition-all hover:-translate-y-1 ${
              a.featured
                ? 'border-teal-500/50 bg-gradient-to-b from-teal-500/[0.09] to-transparent hover:border-teal-400'
                : 'border-white/10 bg-white/[0.02] hover:border-teal-500/40'
            }`}
          >
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-teal-500/10 transition-colors group-hover:bg-teal-500/20">
              <a.icon className="h-5 w-5 text-teal-400" />
            </div>
            <h3 className="font-display text-base font-bold text-white">{a.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-400">{a.description}</p>
            <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold text-teal-400">
              {a.cta}
              <ArrowLeft className="h-3.5 w-3.5 transition-transform group-hover:-translate-x-1" />
            </span>
          </button>
        </Reveal>
      ))}
    </div>
  </section>
);

export default LandingAudiences;
